import ResearchDevelopmentComponent from './ResearchDevelopment.vue'
export default ResearchDevelopmentComponent
